import { Card } from '@auviknetworks/iceberg-ui';
import { Typography } from '@mui/material';
import React from 'react';

export const Group = ({
    children,
    title
}: {
    children: React.ReactNode;
    title: string;
}) => (
    <Card variant="outlined" sx={{ padding: '24px' }}>
        <Typography
            variant="h6"
            color="textSecondary"
            fontWeight={600}
            borderBottom={1}
            borderColor="border.card"
            paddingBottom="24px"
            marginBottom="24px"
        >
            {title}
        </Typography>
        {children}
    </Card>
);
